import omit from 'lodash/omit';
import chunk from 'lodash/chunk';
import qs from 'qs';
import { addOrUpdateParameter } from '../modules/ajio-util/query';
import { readCookie } from '../components/common/Cookie';
import { getFeatureVariant } from '../refresh/organism/ABFeature/Feature';
import isNode from '../modules/ajio-util/isNode';
import CryptoJS from 'crypto-js';

export function getCuratedIdFromRouteParam(param = '') {
  const formattedParam = param || '';
  const curatedIdSearchPatterns = ['?query', '%3Fquery'];

  for (let i = 0; i < curatedIdSearchPatterns.length; i++) {
    if (formattedParam.includes(curatedIdSearchPatterns[i], 0)) {
      return formattedParam.split(curatedIdSearchPatterns[i])[0];
    }
  }
  return formattedParam;
}

export function parseFacets(facets) {
  let results = {};
  if (facets && typeof facets === 'string') {
    const facetsSplits = facets.split(':');
    const facetsChunks = chunk(facetsSplits, 2);
    results = facetsChunks.reduce((acc, item) => {
      const key = item[0];
      const value = item[1];
      if (acc[key]) {
        acc[key].push(value);
      } else {
        acc[key] = [value];
      }
      return acc;
    }, {});
  } else if (facets && typeof facets === 'object') {
    results = facets;
  }
  return results;
}
export function stringifyFacets(facets) {
  let results = '';
  if (typeof facets === 'object') {
    results = Object.keys(facets).reduce((acc, facetId) => {
      if (Array.isArray(facets[facetId])) {
        acc += facets[facetId].reduce((acc1, item) => {
          acc1 += `:${facetId}:${item}`;
          return acc1;
        }, '');
      } else {
        acc += `:${facetId}:${facets[facetId]}`;
      }
      return acc;
    }, '');
  } else {
    results = facets;
  }
  if (results.charAt(0) === ':') {
    results = results.slice(1);
  }
  return results;
}
export function buildQuery(query, options = {}) {
  const { blackList = [], defaultQuery = {} } = options;
  let nextQuery = { ...defaultQuery, ...query };
  if (blackList.length > 0) {
    nextQuery = omit(nextQuery, blackList);
  }
  return nextQuery;
}
export function getDefaultQuery(additionalProps = {}) {
  const defaultQuery = {
    fields: 'SITE',
    currentPage: 0,
    pageSize: 45,
    format: 'json',
    query: ':relevance',
    sortBy: 'relevance'
  };
  return { ...defaultQuery, ...additionalProps };
}
export function buildSearch(query, options = {}) {
  const {
    blackList = ['fields', 'currentPage', 'pageSize', 'format', 'facets', 'sortBy']
  } = options;
  query = omit(query, blackList);
  return `?${qs.stringify(query)}`;
}
export function buildQueryString(template = [], query = {}) {  
  //To prevent duplicate trends and vibes in query param
  let queryData = {...query};
  const hasTrend = queryData?.facets?.includes("trend");
  const hasVibe = queryData?.facets?.includes("vibe");
  if(hasTrend || hasVibe){
    delete queryData?.trend;
    delete queryData?.vibe;
  }
  if (!template || template.length < 1) {
    return '';
  }

  return template.reduce((acc, prop) => {
    if (queryData[prop]) {
      acc += `:${queryData[prop]}`;
    }
    return acc;
  }, '');
}
/**
 *
 * @param {*} queryString Represet value of query key inside Queey Object.
 * @param {*} extraparam  blacklist words
 *
 * This method separate the value of "query" key into (Sort & facets).
 */
export function parseProductQueryString(queryString, extraparam = {}) {
  if (!queryString) {
    return {};
  }
  const queryStringSplits = queryString.toString().split(':');
  const sortBy = queryStringSplits[1];
  const facets = queryStringSplits
    .filter(item => {
      if (Object.keys(extraparam).length) {
        return item && item !== sortBy && extraparam.ignore.indexOf(item) == -1;
      }
      return item && item !== sortBy;
    })
    .join(':');

  const results = {};
  if (sortBy) {
    results.sortBy = sortBy;
  }
  if (facets) {
    results.facets = facets;
  }
  return results;
}
export function getSegmentIds(req, res) {
  const { cohortSegment = '' } = req.cookies;
  if (cohortSegment) {
    return cohortSegment.toString();
  }
  return '';
}

export function getUserCohortIds(req, storeval, inclueDeviceCohort = true, serviceName = 'cms', enableUniversalCohortFlow=false) {
  const { userCohortValues = '', deviceCohortValue = '' } = req.cookies;
  // console.log('User Cohort Values ->' + userCohortValues + ' deviceCohortValues ->'+deviceCohortValue);
  if (userCohortValues?.length === 0 && deviceCohortValue?.length === 0) {
    return;
  }
  const newStoreval = storeval ? `${storeval}_v1` : 'rilfnl_v1';

  let cohortValues = userCohortValues;
  if(!cohortValues && deviceCohortValue && inclueDeviceCohort){
    cohortValues = deviceCohortValue;
  }else if(!cohortValues){
    // if include device cohort is false and we 
    return;
  }
  let cohortValue;
  try {
    const cohortData = JSON.parse(userCohortValues || deviceCohortValue);

    if(enableUniversalCohortFlow) {
      cohortValue = cohortData?.[serviceName]?.cohorts || '';
      return cohortValue;
    }
    // this is old cohort flow based on array
    if(cohortData && Array.isArray(cohortData)){
      cohortData?.forEach(element => {
        const { key, value } = element;
        if (!storeval && key === 'rilfnl_v1') {
          cohortValue = value;
        } else if (newStoreval && newStoreval === key) {
          cohortValue = value;
        }
      });
    }
    else {
      if(enableUniversalCohortFlow) {
        cohortValue = cohortData?.[serviceName]?.cohorts || '';
        return cohortValue;
      }
      cohortValue = cohortData[newStoreval]?.[serviceName]?.cohorts || '';
    }
  } catch (error) {
    console.log('Error parsing cohort value', error)
  }
 
 
  // console.log('GET VALUE FROM COOKIE', cohortValue);
  return cohortValue;
}

export function getCustomerType(req) {
  const { customerType = '' } = req.cookies;
  if (!customerType) {
    return;
  }
  return customerType;
}

export function getPincodeFromCookie(req) {
  const { PC = '' } = req.cookies || {};
  return PC;
}

function buildRequest(request = {}) {
  const routePropsQuery = request.query || {};
  const routePropsQueryString = buildQueryString(['sortBy', 'facets'], {
    ...parseProductQueryString(routePropsQuery.query || ''),
    ...routePropsQuery
  });
  routePropsQuery.query = routePropsQueryString;
  const query = buildQuery(routePropsQuery, {
    blackList: ['clearAllFacets']
  });
  const search = buildSearch(query);
  // const browserPath = request.pathname;
  // browserPath,
  const nextRequest = {
    ...request,
    query,
    search,
    defaultQuery: getDefaultQuery()
  };
  return nextRequest;
}

export function getNextRequest(query = {}, request = {}) {
  return buildRequest({
    ...request,
    query: { ...request.query, ...query }
  });
}

export default {
  stringifyFacets,
  parseFacets
};

export function getRouteSpecificInfo(
  info = '',
  freeTextSearch = '',
  gender = '',
  browserRequest = {}
) {
  const defaultBrandTitle = `${freeTextSearch} Store Online – Buy ${freeTextSearch} products online in India. - Ajio`;
  const defaultBrandDesc = `${freeTextSearch} Shop Online. Buy ${freeTextSearch} products online in India. Huge collection. Order now and avail Great Offers , Cash on Delivery, Easy Returns and Exchange.`;

  const defaultSaleTitle = `Ajio Sale - ${freeTextSearch}. Buy online at ${freeTextSearch}`;
  const defaultSaleDesc = `Buy online at ${freeTextSearch}. Huge footwear and Clothing range. Order now and avail Best Discounts, Cash on Delivery, Easy Returns and Exchange.`;

  const defaultCapsuleTitle = `${freeTextSearch} Online – Buy ${freeTextSearch} collection by Ajio.`;
  const defaultCapsuleDesc = `Buy ${freeTextSearch} collection by Ajio. Handpicked Designs. Order now and avail Great Offers , Cash on Delivery, Easy Returns and Exchange.`;
  const defaultCategoryTitle = gender
    ? `${gender} ${freeTextSearch} online. Buy ${gender} ${freeTextSearch} online in India. – Ajio`
    : `Fashion online. Buy Fashion online in India. – Ajio`;
  const defaultCategoryDesc = gender
    ? `Buy ${freeTextSearch} for ${gender}. Huge Collection. Great Offers and Discounts. Order Now. Avail Cash on Delivery, Easy Returns and Exchange.`
    : `Buy Fashion. Huge Collection. Great Offers and Discounts. Order Now. Avail Cash on Delivery, Easy Returns and Exchange.`;

  if (browserRequest.browserPath && browserRequest.browserPath.lastIndexOf('/b/') > -1) {
    if (info === 'title') {
      return defaultBrandTitle;
    }
    return defaultBrandDesc;
  }
  if (
    browserRequest.browserPath &&
    (browserRequest.browserPath.lastIndexOf('/s/') > -1 ||
      browserRequest.browserPath.lastIndexOf('/s1/') > -1)
  ) {
    if (info === 'title') {
      return defaultSaleTitle;
    }
    return defaultSaleDesc;
  }
  if (
    browserRequest.browserPath &&
    (browserRequest.browserPath.lastIndexOf('/cp/') > -1 ||
      browserRequest.browserPath.lastIndexOf('/capsule/') > -1)
  ) {
    if (info === 'title') {
      return defaultCapsuleTitle;
    }
    return defaultCapsuleDesc;
  }

  if (info === 'title') {
    return defaultCategoryTitle;
  }
  return defaultCategoryDesc;
}

export function calculatePriceInfo(priceInfo = {}) {
  const {
    couponSaving: {
      formattedValue: CouponSavingFormattedValue = '',
      value: CouponSavingValue = 0
    } = {},
    netPrice: {
      // may be this will be price
      formattedValue: NetPriceFormattedValue = '',
      value: NetPriceValue = 0
    } = {},
    originalPrice: {
      // may be this will be MRP
      formattedValue: OriginalPriceFormattedValue = '',
      value: OriginalPriceValue = 0
    } = {},
    discount: { formattedValue: DiscountFormattedValue = '', value: DiscountValue = 0 } = {},
    totalSaving: {
      // mey be this will be TradeDiscount
      formattedValue: TotalSavingFormattedValue = '',
      value: TotalSavingValue = 0
    } = {}
  } = priceInfo;

  return {
    CouponSavingFormattedValue,
    CouponSavingValue,

    NetPriceFormattedValue,
    NetPriceValue,

    OriginalPriceFormattedValue,
    OriginalPriceValue,

    DiscountFormattedValue,
    DiscountValue,

    TotalSavingFormattedValue,
    TotalSavingValue,

    // probable values
    CouponSaving: CouponSavingFormattedValue,
    Price: NetPriceFormattedValue,
    MRP: OriginalPriceFormattedValue,
    TradeDiscount: TotalSavingFormattedValue,
    // is required discount?
    Discount: DiscountFormattedValue

    // for page visit
    // Price,
    // CouponSaving,
    // TradeDiscount,
    // MRP

    // for item remove
    // price,
    //  Discount
  };
}

export function getAppliedPromoFiredMsg(
  appliedPromotions = [],
  orderEntryNumber,
  multiItemPromoAmt
) {
  const appliedPromoObject =
    multiItemPromoAmt === 0 && Array.isArray(appliedPromotions) && appliedPromotions.length > 0
      ? appliedPromotions.find((promotion = {}) => {
          if (Array.isArray(promotion.consumedEntries) && promotion.consumedEntries.length > 0) {
            return promotion.consumedEntries.some((entry = {}) => {
              if (entry.hasOwnProperty('orderEntryNumber')) {
                return entry.orderEntryNumber === orderEntryNumber;
              }
              return false;
            });
          }
          return false;
        })
      : null;
  if (appliedPromoObject) {
    const { promotion: { description = '' } = {} } = appliedPromoObject;
    return description;
  }
  return '';
}

export function addCustomerType(url) {
  try {
    const data = (!isNode() && localStorage && JSON.parse(localStorage.getItem('customerTypeData'))) || {};
    const isExcisting = data ? data.customerType === 'Existing' : false;
    if (isExcisting) {
      return addOrUpdateParameter(url, { user: 'old' });
    }
    return url;
  } catch (e) {
    console.log(e);
    return url;
  }
}

export function getSegmentIdsForClient() {
  const cohortSegment = readCookie('cohortSegment');
  if (cohortSegment) {
    return cohortSegment.toString();
  }
  return '';
}

export function getUserCohortIdsForClient(storeval, serviceName='cms', enableUniversalCohortFlow=false) {
  const userCohortValues = readCookie('userCohortValues');

  if (!userCohortValues) {
    return;
  }
  const newStoreval = storeval ? `${storeval}_v1` : 'rilfnl_v1';
  let cohortValue;
  const cohortData = JSON.parse(userCohortValues);
  if(enableUniversalCohortFlow) {
    cohortValue = cohortData?.[serviceName]?.cohorts || '';
    return cohortValue;
  }
  
  if (cohortData && Array.isArray(cohortData)) {
    cohortData.forEach(element => {
      const { key, value } = element;
      if (!storeval && key === 'rilfnl_v1') {
        cohortValue = value;
      } else if (newStoreval && newStoreval === key) {
        cohortValue = value;
      }
    });
  } else {
    cohortValue = cohortData[newStoreval]?.[serviceName]?.cohorts || '';
  }
  return cohortValue;
}

export function getCustomerTypeForClient() {
  const customerType = readCookie('customerType');
  if (!customerType) {
    return;
  }
  return customerType;
}

export function getProductImagesForPlp(images = []) {
  const imgArray = [];

  images.length > 0 &&
    images.map((image, index) => {
      imgArray.push({
        id: index,
        slideItem: image.url,
        slideDesc: image.altText
      });
    });
  return imgArray;
}

export function getSearchABExpFlags(searchExpFlags) {
  let filterSearchFlag = [];

  if (searchExpFlags?.length > 0) {
    filterSearchFlag = searchExpFlags?.filter(
      flag => getFeatureVariant(Object.keys(flag)[0]) === '1'
    );
  }
  return filterSearchFlag;
}

export function getSearchExpFlags(flags = []) {
  const ABFlagObj = {};

  flags?.map(flag => {
    if (Object.values(flag)[0] !== null) {
      ABFlagObj[Object.keys(flag)[0]] = Object.values(flag)[0];
    }
  });

  return ABFlagObj;
}

export function filterOutProperties(obj = {}, propsToFilterOut = []) {
  return Object.fromEntries(Object.entries(obj).filter(([key]) => propsToFilterOut.includes(key)));
}

export function getCancellationAmountForItem(
  totalPrice = 0,
  convenienceFee = {},
  totalQty = 1,
  remainingQty = 1,
  totalBankDisc = 0,
  noCostEmiDiscount = 0
) {
  const { COD = {}, RVP = {}, delivery = {}, priorityDelivery = {}, rushDelivery = {} } =
    convenienceFee || {};
  const { isFeeCharged: isCodFeeCharged = false, netAmount: codNetAmount = '0' } = COD;
  const { isFeeCharged: isRvpFeeCharged = false, netAmount: rvpNetAmount = '0' } = RVP;
  const {
    isFeeCharged: isDeliveryFeeCharged = false,
    netAmount: deliveryNetAmount = '0'
  } = delivery;
  const {
    isFeeCharged: isPriorityFeeCharged = false,
    netAmount: priorityNetAmount = '0'
  } = priorityDelivery;
  const {
    isFeeCharged: isRushFeeCharged = false,
    netAmount: rushNetAmount = '0'
  } = rushDelivery;

  const refundableFee =
    (!isCodFeeCharged && !isNaN(codNetAmount) ? Number(codNetAmount) : 0) +
    (!isNaN(rvpNetAmount) ? Number(rvpNetAmount) : 0) +
    (!isDeliveryFeeCharged && !isNaN(deliveryNetAmount) ? Number(deliveryNetAmount) : 0) +
    (!isRushFeeCharged && !isNaN(rushNetAmount)
      ? Number(rushNetAmount)
      : !isPriorityFeeCharged && !isNaN(priorityNetAmount)
      ? Number(priorityNetAmount)
      : 0);

  const totalItemPrice = totalPrice && !isNaN(totalPrice) ? Number(totalPrice) : 0;
  const totalItemQty = totalQty && !isNaN(totalQty) ? Number(totalQty) : 1;
  const remainingItemQty = remainingQty && !isNaN(remainingQty) ? Number(remainingQty) : 1;

  const totalPriceForRemainingItem = (totalItemPrice / totalItemQty) * remainingItemQty;
  const totalBankDiscForRemainingItem = (totalBankDisc / totalItemQty) * remainingItemQty;
  const refundableFeeForRemainingItem = (refundableFee / totalItemQty) * remainingItemQty;
  const noCostEmiDiscountForRemainingItem = (noCostEmiDiscount / totalItemQty) * remainingItemQty;
  return (
    totalPriceForRemainingItem -
    totalBankDiscForRemainingItem +
    refundableFeeForRemainingItem -
    noCostEmiDiscountForRemainingItem
  );
}

export function sha256Hex(message) {
  if (!message) return '';

  const hash = CryptoJS.SHA256(message);
  return hash.toString(CryptoJS.enc.Hex);
}

export const isExclusiveDatePast = (date = '') => {
  if (!date) return false;
  let exclusiveDate;
  if (date.includes('T')) {
    exclusiveDate = new Date(date);
  } else {
    const [day, month, year] = date.split('-');
    exclusiveDate = new Date(year, month - 1, day);
  }
  if (Number.isNaN(exclusiveDate.getTime())) return false;
  return exclusiveDate >= new Date();
};

export const convertFacetsToFiltersArray = facets => {
  if (!facets || typeof facets !== 'object') {
    return [];
  }

  return Object.keys(facets).reduce((acc, filterType) => {
    const filterValues = facets[filterType];
    if (Array.isArray(filterValues)) {
      filterValues.forEach((value, position) => {
        acc.push({
          section: 0,
          position: position + 1,
          facet_key: filterType,
          facet_value: value,
          value: value
        });
      });
    } else if (filterValues) {
      acc.push({
        section: 0,
        position: 1,
        facet_key: filterType,
        facet_value: filterValues,
        value: filterValues
      });
    }
    return acc;
  }, []);
};